import styled from "styled-components";
import { TextBold } from "../../styles/GlobalStyledComponents";

export const PrivacyPolicyContainer = styled.div`
    padding: 80px;
    line-height: 26px;
    @media screen and (max-width: 650px) {
        padding: 20px;
    }
    header {
        color: ${props => props.theme.colors.gray6};
        font-weight: 600;
        font-size: 14px;
        font-style: italic;
        margin-bottom: 15px;
    }

    footer {
        color: ${props => props.theme.colors.gray6};
        font-size: 12px;
        margin-top: 15px;
        text-align: center;
    }
    p {
        text-align: justify;
    }
`;

export const PrivacyPolicyTitle = styled.p`
    padding: 20px 0;
    font-weight: 700;
`;

export const PrivacyPolicyContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
`;

export const PrivacyPolicyTextBold = styled.span`
    padding: 10px 0;
    font-weight: 600;
`;

export const PrivacyPolicyImportantText = styled(TextBold)`
    text-decoration: underline;
`;